import React, { useState } from 'react';
import ConfirmationBlock from '../ConfirmationBlock';
import deleteImg from '../../../assets/images/warning-gif.gif';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Toast from '../../molecules/Toast';
import linkedinService from '../../../services/linkedinService';
import leadService from '../../../services/leadService';

const DeleteTask = () => {
  const navigate = useNavigate();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));
  const location = useLocation();
  const taskId = location.state?.taskId;
  const isLinkedinTask = location?.state?.isLinkedinTask;

  const handleDeleteTask = async _ => {
    try {
      setLoading(true);
      let res;
      if (isLinkedinTask) {
        res = await linkedinService.deleteLinkedinTask(taskId);
      } else {
        res = await leadService.deleteTask(taskId);
      }
      if (res?.success) {
        Toast({ type: 'success', message: res?.message });

        setConfirmDelete(true);
        navigate('/task');
      }
    } catch (error) {
      Toast({ type: 'error', message: error?.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {!confirmDelete ? (
        <ConfirmationBlock
          img={deleteImg}
          title="Delete this Task!"
          description="Are you sure you want to delete this task? This action cannot be undone."
          btns={
            <>
              <Button onClick={() => navigate('/task')}>Cancel</Button>
              <Button variant="danger" onClick={() => handleDeleteTask()} loader={loading} disabled={loading}>
                Delete
              </Button>
            </>
          }
        />
      ) : (
        <ConfirmationBlock
          img={confirmImg}
          title="Task Deleted Successfully!"
          btns={
            <Button
              onClick={() => {
                navigate('/task');
                refetch();
              }}>
              Go Back
            </Button>
          }
        />
      )}
    </div>
  );
};

export default DeleteTask;
